import { FaRegDotCircle } from "react-icons/fa";

export default function ModalComponent({ data }) {
    return (
        <div className="container-fluid font-monospace">
            {/* <div className="h3 mb-3">Detail</div> */}
            <div className="row">
                <ModalDetail title="primer_id" text={data?.primer_id ?? '-'} />
                <ModalDetail title="any" text={data?.any ?? '-'} />
                <ModalDetail title="gc" text={data?.gc ?? '-'} />
                <ModalDetail title="len" text={data?.len ?? '-'} />
                <ModalDetail title="sequence" text={data?.sequence ?? '-'} />
                <ModalDetail title="snp_id" text={data?.snp_id ?? '-'} />
                <ModalDetail title="snp_position" text={data?.snp_position ?? '-'} />
                <ModalDetail title="start" text={data?.start ?? '-'} />
                <ModalDetail title="tm" text={data?.tm ?? '-'} />
                <ModalDetail title="variation_type" text={data?.variation_type ?? '-'} />
                <ModalDetail title="n3seq" text={data?.n3seq ?? '-'} />
                <ModalDetail title="product_size" text={data?.product_size ?? '-'} />
                <ModalDetail title="rice_cultivar_th" text={data?.rice_cultivar_th ?? '-'} />
                <ModalDetail title="rice_cultivar_en" text={data?.rice_cultivar_en ?? '-'} />
            </div>
        </div>
    );
}

function ModalDetail({ title, text }) {
    return (
        <div className="col-12 col-md-6 col-xl-4 col-xxl-3 mb-4">
            <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                <div className="mx-2">
                    <FaRegDotCircle className="text-primary" />
                </div>
                <div>{title}</div>
            </div>
            <div className="bg-light p-1 rounded" style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word", fontFamily: "monospace" }}>
                {text}
            </div>
        </div>
    );
}
